/* eslint-disable */
import spotifyLogo from '@/assets/images/landing/spotify-logo.svg';
import appleMusicLogo from '@/assets/images/landing/apple-music.svg';
import youtubeMusicLogo from '@/assets/images/landing/youtube-music.png';
import deezerLogo from '@/assets/images/landing/deezer-logo.svg';
import soundcloudLogo from '@/assets/images/landing/soundcloud-logo.svg';
import amazonMusicLogo from '@/assets/images/landing/amazon-music-logo.svg';
import beatportLogo from '@/assets/images/landing/beatport-logo.svg';
import boomplayLogo from '@/assets/images/landing/boomplay-logo.png';
import anghamiLogo from '@/assets/images/landing/anghami-logo.png';
import metaLogo from '@/assets/images/landing/meta-logo.svg';
import lineLogo from '@/assets/images/landing/line-logo.svg';
import pandoraLogo from '@/assets/images/landing/pandora-logo.svg';
import tidalLogo from '@/assets/images/landing/tidal-logo.svg';
import neteaseLogo from '@/assets/images/landing/netease-logo.svg';
import tiktokLogo from '@/assets/images/landing/tiktok-logo.svg';
import bandcampLogo from '@/assets/images/landing/bandcamp-logo2.png';
import qqMusicLogo from '@/assets/images/landing/qq-music-logo.svg';
import trebelLogo from '@/assets/images/landing/trebel-logo.png';
import iHeartRadioLogo from '@/assets/images/landing/iheart-radio-logo.png';
import imusicaLogo from '@/assets/images/landing/imusica-logo.svg';

export default [{
  name: "Spotify",
  id: 746109,
  required: true,
  logo: spotifyLogo,
  type: 'streaming',
  category: 'major'
}, {
  name: "Apple Music",
  id: 1330598,
  required: true,
  logo: appleMusicLogo,
  type: 'streaming',
  category: 'major'
}, {
  name: "YouTube Music & Content ID",
  id: 3405271817,
  logo: youtubeMusicLogo,
  type: 'streaming',
  category: 'major'
}, {
  name: "YouTube Content ID",
  id: 1048705,
  logo: youtubeMusicLogo,
  type: 'streaming',
  category: 'major'
}, {
  name: "YouTube Music",
  id: 13285026,
  required: true,
  logo: youtubeMusicLogo,
  type: 'streaming',
  category: 'major'
}, {
  name: "Deezer",
  id: 2100357,
  required: true,
  logo: deezerLogo,
  type: 'streaming',
  category: 'major'
}, {
  name: "Google Music",
  id: 13285026,
  required: true,
  type: 'streaming',
  category: 'major'
}, {
  name: "SoundCloud Content ID",
  id: 35299696,
  required: true,
  logo: soundcloudLogo,
  type: 'streaming',
  category: 'indie'
}, {
  name: "JioSaavn",
  id: 316911752,
  required: true,
  type: 'streaming',
  category: 'regional'
}, {
  name: "Fizy",
  id: 1988507361,
  type: 'streaming',
  category: 'regional'
}, {
  name: "Resso",
  id: 1963181516,
  type: 'streaming',
  category: 'regional'
}, {
  name: "MonkingMe",
  id: 3287973537,
  type: 'streaming',
  category: 'indie'
}, {
  name: "Amazon",
  id: 99268,
  required: true,
  logo: amazonMusicLogo,
  type: 'streaming',
  category: 'major'
}, {
  name: "Shazam",
  id: 4266325,
  type: 'streaming',
  category: 'major'
}, {
  name: "Beatport",
  id: 89882,
  required: true,
  logo: beatportLogo,
  type: 'sales',
  category: 'indie'
}, {
  name: "Boomplay",
  id: 1514168496,
  logo: boomplayLogo,
  type: 'streaming',
  category: 'regional'
}, {
  name: "Napster",
  id: 103731,
  type: 'streaming',
  category: 'indie'
}, {
  name: "iHeartRadio",
  id: 3441649,
  logo: iHeartRadioLogo,
  type: 'streaming',
  category: 'major'
}, {
  name: "24-7 Entertainment",
  id: 464139,
  type: 'streaming',
  category: 'indie'
}, {
  name: "7Digital",
  id: 247916,
  required: true,
  type: 'streaming',
  category: 'indie'
}, {
  name: "Akazoo",
  id: 62849862,
  required: true,
  type: 'streaming',
  category: 'indie'
}, {
  name: "Anghami",
  id: 20799134,
  logo: anghamiLogo,
  type: 'streaming',
  category: 'regional'
}, {
  name: "AWA",
  id: 847103579,
  required: true,
  type: 'streaming',
  category: 'regional'
}, {
  name: "Dubset Media",
  id: 1127228619,
  type: 'streaming',
  category: 'indie'
}, {
  name: "Facebook Audio Library",
  id: 1499657856,
  logo: metaLogo,
  type: 'streaming',
  category: 'major'
}, {
  name: "Facebook Fingerprinting",
  id: 1415672002,
  logo: metaLogo,
  type: 'streaming',
  category: 'major'
}, {
  name: "Gracenote",
  id: 9538495,
  type: 'streaming',
  category: 'major'
}, {
  name: "iMusica",
  id: 103725,
  required: true,
  type: 'streaming',
  category: 'regional'
}, {
  name: "LINE Music",
  id: 1232212955,
  required: true,
  logo: lineLogo,
  type: 'streaming',
  category: 'regional'
}, {
  name: "Audible Magic",
  id: 8771887,
  type: 'streaming',
  category: 'indie'
}, {
  name: "Neurotic Media",
  id: 62873543,
  type: 'streaming',
  category: 'indie'
}, {
  name: "Pandora",
  id: 7851192,
  required: true,
  logo: pandoraLogo,
  type: 'streaming',
  category: 'major'
}, {
  name: "Simfy Africa",
  id: 78395129,
  type: 'streaming',
  category: 'regional'
}, {
  name: "Sirius XM",
  id: 1239927070,
  type: 'streaming',
  category: 'major'
}, {
  name: "TIDAL",
  id: 3440259,
  required: true,
  logo: tidalLogo,
  type: 'streaming',
  category: 'major'
}, {
  name: "TIM Music",
  id: 1207204780,
  type: 'streaming',
  category: 'regional'
}, {
  name: "Ultimate China (Aggregation Only)",
  id: 1130737243,
  type: 'streaming',
  category: 'regional'
}, {
  name: "Xiami",
  id: 1234931270,
  type: 'streaming',
  category: 'regional'
}, {
  name: "Yandex Music",
  id: 1209287754,
  type: 'streaming',
  category: 'regional'
}, {
  name: "KkBox",
  id: 121452605,
  type: 'streaming',
  category: 'regional'
}, {
  name: "Mixcloud",
  id: 1684139985,
  type: 'streaming',
  category: 'indie'
}, {
  name: "NetEase Cloud Music",
  id: 1382854531,
  required: true,
  logo: neteaseLogo,
  type: 'streaming',
  category: 'regional'
}, {
  name: "Tesla Music",
  id: 1635935812,
  type: 'streaming',
  category: 'major'
}, {
  name: "TikTok",
  id: 1809226414,
  logo: tiktokLogo,
  type: 'streaming',
  category: 'major'
}, {
  name: "Bandcamp",
  id: "bandcamp",
  logo: bandcampLogo,
  type: 'sales',
  category: 'indie'
}, {
  name: "QQ Music",
  id: "qqmusic",
  logo: qqMusicLogo,
  type: 'streaming',
  category: 'regional'
}, {
  name: "FLO Music",
  id: 2215088010
}, {
  name: "Bugs",
  id: 1501350807
}, {
  name: "Genie Music",
  id: 2697871022
}, {
  name: "Naver",
  id: 1674795424
}, {
  name: "Trebel",
  id: 4668622402,
  logo: trebelLogo,
  type: 'streaming',
  category: 'major'
}]